// Google Analytics 4 — lightweight wrapper.
// No-ops if REACT_APP_GA4_MEASUREMENT_ID is not set.
// Skips tracking on /admin/* paths.

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
let initialized = false;

export function initGA() {
  if (initialized || !GA_ID || typeof window === "undefined") return;
  initialized = true;

  // Inject gtag.js
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  // Disable automatic page_view — we'll send them on route changes
  gtag("config", GA_ID, { send_page_view: false });
}

function isAdminPath(path) {
  return typeof path === "string" && path.startsWith("/admin");
}

export function trackPageView(path, title) {
  if (!GA_ID || !window.gtag) return;
  if (isAdminPath(path)) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || !window.gtag) return;
  if (isAdminPath(window.location.pathname)) return;
  window.gtag("event", name, params);
}
